import { createContext, useContext, type ReactNode } from 'react';
import type { AuthLoginOptions, User } from './types';

export interface AuthSession {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (token: string, userFromResponse?: User, options?: AuthLoginOptions) => Promise<User | undefined>;
  logout: () => Promise<void>;
  refreshUser: () => Promise<void>;
  clearLocalSession: () => Promise<void>;
}

const AuthSessionContext = createContext<AuthSession | undefined>(undefined);

export function AuthSessionProvider({ value, children }: { value: AuthSession; children: ReactNode }) {
  return <AuthSessionContext.Provider value={value}>{children}</AuthSessionContext.Provider>;
}

export function useAuth(): AuthSession {
  const context = useContext(AuthSessionContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
